import React, { useState, useMemo, useEffect } from "react";
import { IoIosArrowDropdown } from "react-icons/io";
import { RiResetLeftLine } from "react-icons/ri";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
const LongHaulToController = ({
  data,
  setFilteredData,
  openStates,
  setOpenStates,
  setSelectedFilters,
}) => {
  // State for search inputs
  const [searchValues, setSearchValues] = useState({
    Date: "",
    Ex: "",
    TpSp: "",
  });
  // State for selected filters
  const [selectedDate, setSelectedDate] = useState(new Set());
  const [selectedEx, setSelectedEx] = useState(new Set());
  const [selectedTpSp, setSelectedTpSp] = useState(new Set());
  useEffect(() => {
    setSelectedFilters({ selectedTpSp, selectedEx, selectedDate });
  }, [selectedTpSp, selectedEx, selectedDate]);
  const toggleSelection = (setFunc, currentSet, value) => {
    const newSet = new Set(currentSet);
    newSet.has(value) ? newSet.delete(value) : newSet.add(value);
    setFunc(newSet);
  };

  const toggleDropdown = (title) => {
    setOpenStates((p) => ({
      ...p,
      [title]: !p[title],
    }));
  };

  const handleSearchChange = (title, value) => {
    setSearchValues((prev) => ({
      ...prev,
      [title]: value,
    }));
  };
  // Initialize filter options
  const defaultSetup = () => {
    if (!data?.length) return;
    const allDate = [
      ...new Set(data.map((y) => y.A_DATE).filter((v) => v != null)),
    ];
    const allEx = [...new Set(data.map((d) => d.EX).filter((v) => v != null))];
    const allTpSp = [
      ...new Set(data.map((d) => d.TP_SP).filter((v) => v != null)),
    ];

    setSelectedDate(new Set(allDate));
    setSelectedEx(new Set(allEx));
    setSelectedTpSp(new Set(allTpSp));

    setSearchValues({
      Date: "",
      Ex: "",
      TpSp: "",
    });
    setOpenStates({
      Date: false,
      Ex: false,
      TpSp: false,
    });
  };

  useEffect(() => {
    defaultSetup();
  }, [data]);
  // Available options for each filter

  const availableDate = useMemo(() => {
    return [...new Set(data.map((y) => y.A_DATE).filter((v) => v != null))];
  }, [data]);
  const availableEx = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter((entry) => selectedDate.has(entry.A_DATE))
          .map((m) => m.EX)
          .filter((v) => v != null)
      ),
    ];
  }, [data, selectedDate]);
  const availableTpSp = useMemo(() => {
    return [
      ...new Set(
        data
          ?.filter(
            (entry) =>
              selectedDate.has(entry.A_DATE) && selectedEx.has(entry.EX)
          )
          .map((d) => d.TP_SP)
          .filter((v) => v != null)
      ),
    ];
  }, [data, selectedDate, selectedEx]);

  // Filtered data based on selections
  const filteredData = useMemo(() => {
    if (
      !data ||
      !Array.isArray(data) ||
      selectedDate.size === 0 ||
      selectedEx.size === 0 ||
      selectedTpSp.size === 0
    ) {
      return [];
    }

    return data.filter((entry) => {
      return (
        selectedDate.has(entry.A_DATE) &&
        selectedEx.has(entry.EX) &&
        selectedTpSp.has(entry.TP_SP)
      );
    });
  }, [data, selectedDate, selectedEx, selectedTpSp]);
  // Propagate filteredData to parent component
  useEffect(() => {
    setFilteredData(filteredData);
  }, [filteredData]);

  const renderCheckboxList = (title, items, selectedSet, setFunc) => {
    const filteredItems = items.filter((item) =>
      item
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchValues[title]?.toLowerCase() || "")
    );
    return (
      <div className="col-md mt-2 p-1">
        <div
          onClick={(e) => e.stopPropagation()}
          className="bg-light"
          style={{
            position: "relative",
            fontSize: 12,
            borderRadius: "5px",
          }}
        >
          <div
            className="papaDiv"
            onClick={() => toggleDropdown(title)}
            style={{
              border: "1px solid #ccc",
              padding: "8px",
              cursor: "pointer",
              minWidth: "150px",
              maxHeight: "50px",
              overflow: "hidden",
              userSelect: "none",
            }}
          >
            Select {title} {"  "}
            <IoIosArrowDropdown
              style={{
                fontSize: 15,
                transition: "transform 0.3s ease",
                transform: openStates[title]
                  ? "rotate(180deg)"
                  : "rotate(0deg)",
              }}
            />
          </div>
          {openStates[title] && (
            <div
              className="papaDiv"
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                border: "1px solid #ccc",
                background: "#fff",
                zIndex: 10,
              }}
            >
              <strong>{title}</strong>
              <input
                style={{ height: "25px", width: "90%" }}
                className="form-control ms-2 mb-1 me-2"
                type="search"
                placeholder={`Search ${title}...`}
                aria-label={`Search ${title}`}
                value={searchValues[title] || ""}
                onChange={(e) => {
                  handleSearchChange(title, e.target.value);
                }}
              />
              <hr className="m-0 p-0" />
              <div
                className="row suggestion mt-1"
                key={filteredItems.length}
                style={{
                  maxHeight: "250px",
                  minHeight: "50px",
                  overflowY: "auto",
                }}
              >
                {filteredItems.length > 0 ? (
                  filteredItems.map((item, index) => (
                    <div
                      key={index}
                      className="col-sx fade-in"
                      style={{ fontSize: "12px" }}
                    >
                      <label
                        className="ms-1 text-start"
                        key={item}
                        style={{ display: "block", cursor: "pointer" }}
                      >
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={selectedSet.has(item)}
                          onChange={() =>
                            toggleSelection(setFunc, selectedSet, item)
                          }
                        />{" "}
                        {/* {title === "Months"
                          ? getMonthAbbreviation(item, true)
                          : item || "N/A"} */}
                        {item?.slice(0, 10)}
                      </label>
                    </div>
                  ))
                ) : (
                  <div className="col-md-12 text-center">No items found</div>
                )}
              </div>
              <hr className="m-0 p-0" />
              <div className="d-flex justify-content-evenly mt-1">
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => setFunc(new Set(filteredItems))}
                >
                  Select All
                </button>
                <button
                  className="btn btn-sm btn-outline-success"
                  onClick={() => setFunc(new Set())}
                >
                  Clear All
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="papaDiv">
      <div
        className="row "
        style={{
          border: "1px solid #ccc",
          background: "rgba(255, 255, 255, 0.22)",
          boxShadow: "5px 5px 20px rgba(7, 7, 7, 0.3)",
          backdropFilter: "blur(15px)",
          WebkitBackdropFilter: "blur(10px)",
        }}
      >
        {renderCheckboxList(
          "Date",
          availableDate,
          selectedDate,
          setSelectedDate
        )}
        {renderCheckboxList("Ex", availableEx, selectedEx, setSelectedEx)}{" "}
        {renderCheckboxList(
          "TpSp",
          availableTpSp,
          selectedTpSp,
          setSelectedTpSp
        )}
        <OverlayTrigger
          delay={{ show: 100, hide: 200 }}
          overlay={<Tooltip id="tooltip-reset">Reset Filter</Tooltip>}
        >
          <div
            className="btn btn-sm btn-danger d-flex justify-content-center align-items-center mt-1 mb-1"
            style={{
              maxWidth: "35px",
              boxShadow: "3px 3px 10px rgba(52, 80, 142, 0.5)",
            }}
            onClick={defaultSetup}
          >
            <RiResetLeftLine style={{ fontSize: "15px", fontWeight: "bold" }} />
          </div>
        </OverlayTrigger>
      </div>
    </div>
  );
};

export default LongHaulToController;
